<template>
  <div class="file-upload-container">
    <el-upload
      ref="elUploadEl"
      :action="actionUrl"
      :file-list="files"
      :headers="header"
      :show-file-list="false"
      :accept="accept"
      :limit="limit"
      :multiple="multiple"
      :before-upload="handleBeforeUpload"
      :on-progress="handleProgress"
      :on-exceed="handleExceed"
      :on-success="handleSuccess"
      :on-error="handleError"
      :with-credentials="withCredentials"
    >
      <el-tooltip placement="top" effect="light">
        <div slot="content">
          <span>附件格式支持：{{ acceptLabel }}</span>
          <br />
          <span>附件大小限制：单个文件不超过{{ size }}MB</span>
          <br />
          <span>附件个数限制：最多{{ limit }}个</span>
        </div>
        <el-button size="mini" round icon="el-icon-plus" v-if="!readonly"
          >上传</el-button
        >
      </el-tooltip>
    </el-upload>
    <el-button
      size="mini"
      round
      icon="el-icon-delete"
      @click="handleClear"
      v-if="(!readonly && files.length > 0) || clearOrNot === true"
      >清空</el-button
    >
    <slot name="append"></slot>
  </div>
</template>
<script>
import utils from "@/eco-ui-util.js";
import { setTimeout } from "timers";
// import func from '../../../vue-temp/vue-editor-bridge';
export default {
  name: "file-upload",
  props: {
    withCredentials: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      required: true
    },
    showClear: {
      type: Array
    },
    actionUrl: {
      type: String,
      required: true
    },
    multiple: {
      type: Boolean
    },
    accept: {
      type: String
    },
    limit: {
      type: Number,
      default: 5
    },
    header: {
      type: Object
    },
    size: {
      type: Number,
      default: 50
    },
    readonly: {
      type: Boolean,
      default: false
    },
    beforeUpload: {
      type: Function
    },
    onSuccess: {
      type: Function
    },
    onError: {
      type: Function
    }
  },
  data() {
    return {
      files: [],
      clearOrNot: false
    };
  },
  watch: {
    showClear: function(newVal) {
      if (newVal && newVal.length > 0) {
        this.clearOrNot = true;
      } else {
        this.clearOrNot = false;
      }
    },
    files: function(newVal) {
      if (newVal && newVal.constructor === Array) {
        let ary = [];
        newVal.forEach(m => {
          if (m && m.constructor === Object) {
            ary.push(m);
          } else if (m && m.constructor === File) {
            var name = m.name;
            var index = name.lastIndexOf(".");
            var type = name.substring(index + 1, name.length);
            ary.push({
              name: name,
              size: m.size,
              percentage: m.percentage,
              status: m.status,
              state: m.state,
              response: m.response,
              type: type,
              uid: m.uid
            });
          }
        });
        this.$emit("input", ary);
      }
    }
  },
  computed: {
    acceptLabel: function() {
      return this.accept ? this.accept : "所有格式";
    }
    // limit2: function() {
    //   if (this.showClear && this.showClear.length > 0) {
    //     if (this.files && this.files.length > 0) {
    //       // return this.limit
    //       //   ? this.limit - this.showClear.length + this.files.length
    //       //   : null;
    //       return this.limit ? this.limit : null;
    //     } else {
    //       return this.limit ? this.limit - this.showClear.length : null;
    //     }
    //   } else {
    //     return this.limit ? this.limit : null;
    //   }
    // }
  },
  created() {
    this.files = this.value || [];
  },
  methods: {}
};
</script>
<style lang="stylus" scoped>
.el-upload {
  display: inline;
  text-align: center;
  cursor: pointer;
  outline: none;
}

div.file-upload-container > div {
  display: inline-block;
  margin-right: 10px;
}
</style>
